import React from 'react';
import { Form } from 'antd';
import { FormListProps as FormListCopyProps } from 'antd/lib/form';

export type FormListProps = FormListCopyProps;

const ProFormList: React.FC<FormListProps> = props => {
  const { children, ...resProps } = props;
  return <Form.List {...resProps}>{children}</Form.List>;
};

export default ProFormList;
